import React from 'react';
import { Icon } from '@blueprintjs/core';
import codeManager from '../codemanager';

export default class Scheduler extends React.Component {

    getSchedule(instrs, model) {

        if (instrs.length === 0)
            return [];

        const paths = instrs.map(instr => codeManager.getPathForInstruction(instr, model));
        const schedule = [];

        // Tries to scedule the rest of instruction number ix given that phase "phase" is scheduled for cycle "cycle".
        // If successful, returns "ok", else returns the abbreviation of the hazard due to which the schedule fails.
        function trySchedule(ix, phase, cycle) {
            for (let l=0; l<phase.latency; l++) {
                schedule[ix][cycle+l] = {phase: phase, event: "none"};
                const h = checkHazard(ix, cycle+l);
                if (h !== "none")
                    return h;
            }

            // check if last phase                
            let res = "OK";
            const pix = paths[ix].phases.indexOf(phase);
            if (pix === paths[ix].phases.length-1) {
                for (let l=0; l<phase.latency; l++)
                    schedule[ix][cycle+l].event = "exec";
                return res;
            }
            // try to schedule the next phase
            const nextPhase = paths[ix].phases[pix+1];
            const maxDelay = phase.canDelay ? Number.MAX_SAFE_INTEGER : 1;
            for (let d=1; d<=maxDelay; d++) {
                res = trySchedule(ix, nextPhase, cycle+phase.latency-1+d);
                if (res === "OK") {
                    for (let l=0; l<phase.latency; l++)
                        schedule[ix][cycle+d-1+l].event = "exec";
                    return res;
                }
                else {
                    schedule[ix][cycle+d-1].event = res;
                    schedule[ix][cycle+d].phase = phase;
                }
            }
            return res;
        }

        function checkHazard(ix, cycle) {
            const phase = schedule[ix][cycle].phase;
            // checking structural hazard
            for (let i=0; i<ix; i++)
                if (schedule[i][cycle] && schedule[i][cycle].phase.label === phase.label)
                    return "Feld.";                    
            // checking for RAW hazards
            if (paths[ix].opARequired === phase.label) {
                for (let j=ix-1; j>=0; j--)
                    if (instrs[j].targetReg && instrs[ix].regA === instrs[j].targetReg) { // RAW dependency, check needed
                        for (let c=cycle; schedule[j][c]; c++)
                            if (schedule[j][c].phase.label === paths[j].targetProvided)
                                return "RAW-" + instrs[ix].regA + "";
                        break;
                    }
            }
            if (paths[ix].opBRequired === phase.label) {
                for (let j=ix-1; j>=0; j--)
                    if (instrs[j].targetReg && instrs[ix].regB === instrs[j].targetReg) { // RAW dependency, check needed
                        for (let c=cycle; schedule[j][c]; c++)
                            if (schedule[j][c].phase.label === paths[j].targetProvided)
                                return "RAW-" + instrs[ix].regB + "";
                        break;
                    }
            }
            // checking WAW hazards
            if (phase.label === paths[ix].registerWriteBack)
                for (let j=ix-1; j>=0; j--)
                    if (instrs[ix].targetReg === instrs[j].targetReg && schedule[j][cycle])
                        return "WAW-" + instrs[ix].targetReg + "";
            // checking WAR hazards
            if (phase.label === paths[ix].registerWriteBack)
                for (let j=ix-1; j>=0; j--)
                    if (instrs[ix].targetReg === instrs[j].regA || instrs[ix].targetReg === instrs[j].regB) { // WAR dependency, check needed
                        for (let c=cycle+1; schedule[j][c]; c++)
                            if (schedule[j][c].phase.label === paths[j].registerReadOut)
                                return "WAR-" + instrs[ix].targetReg + "";
                        break;                            
                    }
            return "none";
        }


        for (let ix=0; ix<instrs.length; ix++) {
            let startCycle = 0;
            if (ix > 0) {
                while (!schedule[ix-1][startCycle])
                    startCycle++;
                while (schedule[ix-1][startCycle].phase === paths[ix-1].phases[0])
                    startCycle++;
            }
            schedule[ix] = [];
            trySchedule(ix, paths[ix].phases[0], startCycle);
        }
        return schedule;
    }

    getForwarding(instrs, model, schedule) {

        if (instrs.length === 0)
            return null;
        const paths = instrs.map(instr => codeManager.getPathForInstruction(instr, model));
    
        function findLastCycle(sch, phaseLabel) {
            for (let i=sch.length-1; i>=0; i--)
                if (sch[i].phase.label === phaseLabel)
                    return i;
            return -1;
        }

        const forwarding = [[]];
        for (let ix=1; ix<instrs.length; ix++) {
            forwarding[ix] = [];
            // check operand A
            const cyclA = findLastCycle(schedule[ix], paths[ix].opARequired);
            for (let j=ix-1; j>=0; j--)
                if (instrs[ix].regA === instrs[j].targetReg && schedule[j][cyclA]) {
                    forwarding[ix].push({register: instrs[ix].regA, cycle: cyclA, source: schedule[j][cyclA].phase.input});
                    break;
                }
            // check operand B
            const cyclB = findLastCycle(schedule[ix], paths[ix].opBRequired);
            for (let j=ix-1; j>=0; j--)
                if (instrs[ix].regB === instrs[j].targetReg && schedule[j][cyclB]) {
                    forwarding[ix].push({register: instrs[ix].regB, cycle: cyclB, source: schedule[j][cyclB].phase.input});
                    break;
                }
        }
        return forwarding;
    }

    render() {
        if (this.props.instrList && this.props.pipelineModel) {
            const instrs = this.props.instrList.filter(x => x.error==="");
            if (instrs.length === 0)
                return <></>;

            if (!codeManager.fitsPipeline(instrs, this.props.pipelineModel))
                return <div className="code-error-area">
                        <div><Icon icon="error"/>&nbsp;Ez a pipeline nem tudja végrehajtani ezt az utasítássorozatot!</div>
                    </div>

            const schedule = this.getSchedule(instrs, this.props.pipelineModel);
            const forwarding = this.getForwarding(instrs, this.props.pipelineModel, schedule);
            const maxLength = Math.max(...schedule.map(x => x.length));

            return <div className="pipeline-schedule-table-container"><table className="pipeline-schedule-table">
                <thead>
                    <tr>
                        <th>Utasítások</th>
                        {Array.from(Array(maxLength), (x, ix) => <th key={ix}>{ix+1}</th>)}
                        <th>Forwarding</th>
                    </tr>
                </thead>
                <tbody>
                    {schedule.map((row, ix) => {
                        return <tr key={instrs[ix].line}>
                            <td>{instrs[ix].code}</td>
                            {Array.from(Array(maxLength), (x,ix) => {
                                if (row[ix] && row[ix].event !== "exec")
                                    return <td key={ix} className="lostcycle"> 
                                        <div>{row[ix].phase.label}</div>
                                        <div>{row[ix].event}</div>
                                        </td>;
                                else if (row[ix])
                                    return <td key={ix}> {row[ix].phase.label} </td>;
                                else
                                    return <td key={ix}></td>;
                                /*if (row[ix] && row[ix-1] && row[ix].phase === row[ix-1].phase && row[ix-1].event !== "exec")
                                    return <td key={ix} className="lostcycle"> {row[ix-1].event} </td>;
                                if (row[ix] && (!row[ix-1] || row[ix].phase !== row[ix-1].phase || row[ix-1].event === "exec"))
                                    return <td key={ix}> {row[ix].phase.label} </td>;
                                return <td key={ix}></td>;*/
                            })}
                            <td>{forwarding[ix].map(x => x.source +" (" + x.register + ")").join(", ")}</td>
                        </tr>
                    })}
                </tbody>
            </table></div>;
        }
        else
            return <></>;
    }
};